import { CustomMarkerBuilderI } from 'src/app/interfaces/map.interface';
import { UserRole } from 'src/app/swagger-api';
import { MapMarker } from '../../map.enum';
import {
  AggregatedCommunityMarkerBuilder,
  AggregatedDoctorMarkerBuilder,
  AggregatedMedStaffMarkerBuilder,
  AggregatedOrganizationMarkerBuilder,
  AggregatedPatientMarkerBuilder,
  AggregatedProjectMarkerBuilder,
  AggregatedResearcherMarkerBuilder,
} from './aggregated-items-marker.builder';
import { CovidMarkerBuilder } from './covid-marker.builder';
import { CommunityMarkerBuilder, ProjectMarkerBuilder } from './non-aggregated-community-project-marker.builder';
import {
  DoctorMarkerBuilder,
  MedStaffMarkerBuilder,
  OrganizationMarkerBuilder,
  PatientMarkerBuilder,
  ResearcherMarkerBuilder,
} from './non-aggregated-user-marker.builder';

export class CustomMarkerBuilderFactory {
  public static getBuilder(type: string): CustomMarkerBuilderI {
    return CustomMarkerBuilderFactory.createCustomMarkerBuilder(type);
  }

  public static createCustomMarkerBuilder(type: string): CustomMarkerBuilderI {
    switch (type) {
      case MapMarker.COVID:
        return new CovidMarkerBuilder(type);

      case MapMarker.AGGREGATION_COMMUNITY:
        return new AggregatedCommunityMarkerBuilder(type);

      case MapMarker.AGGREGATION_PROJECT:
        return new AggregatedProjectMarkerBuilder(type);

      case MapMarker.AGGREGATION_ORGANIZATION:
        return new AggregatedOrganizationMarkerBuilder(type);

      case MapMarker.AGGREGATION_DOCTOR:
        return new AggregatedDoctorMarkerBuilder(type);

      case MapMarker.AGGREGATION_MED_STAFF:
        return new AggregatedMedStaffMarkerBuilder(type);

      case MapMarker.AGGREGATION_PATIENT:
        return new AggregatedPatientMarkerBuilder(type);

      case MapMarker.AGGREGATION_RESEARCHER:
        return new AggregatedResearcherMarkerBuilder(type);

      case MapMarker.COMMUNITY:
        return new CommunityMarkerBuilder(type);

      case MapMarker.PROJECT:
        return new ProjectMarkerBuilder(type);

      case UserRole.Organization:
        return new OrganizationMarkerBuilder(type);

      case UserRole.MedStaff:
        return new MedStaffMarkerBuilder(type);

      case UserRole.Doctor:
        return new DoctorMarkerBuilder(type);

      case UserRole.Patient:
        return new PatientMarkerBuilder(type);

      case UserRole.Researcher:
        return new ResearcherMarkerBuilder(type);

      default:
        throw new Error(`Unsupported marker type: ${type}`);
    }
  }
}
